module.exports = __webpack_public_path__ + "static/img/fivedragons_en.e790d5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/fivedragons_en.png
// module id = VPlW
// module chunks = 1